(function(){
  'use strict';
  var serverLocalizedPage=document.querySelector('[data-deckaura-tools-server-i18n]');
  if(serverLocalizedPage){
    document.documentElement.setAttribute('data-deckaura-tools-language',String(document.documentElement.lang||'').split('-')[0].toLowerCase());
    return;
  }
  var rawDictionary=window.DeckauraToolTranslations||{};
  var rawEnterpriseProse=window.DeckauraEnterpriseProseTranslations||{};
  var rawEnterprisePrefixes=window.DeckauraEnterpriseProsePrefixes||[];
  var localizedRoutes=window.DeckauraLocalizedRoutes||{};
  var attributes=['placeholder','aria-label','title','alt'];
  function key(value){return String(value||'').replace(/\s+/g,' ').trim();}
  function repeatedWordRun(value){
    var words=String(value||'').match(/[A-Za-zÀ-ÿ]{1,30}/g)||[],previous='',run=0;
    for(var i=0;i<words.length;i++){
      var current=words[i].toLocaleLowerCase();
      if(current===previous){run+=1;if(run>=5)return true;}else{previous=current;run=1;}
    }
    return false;
  }
  function safeTranslation(source,value){
    var normalizedSource=key(source),normalizedValue=key(value);
    if(!normalizedSource||!normalizedValue||normalizedSource===normalizedValue)return'';
    if(/(?:setAttribute|querySelector|getElementById|addEventListener|JSON-LD|(?:^|[;])\s*(?:var|const|let)\b|[{}]|=>|===|!==)/i.test(normalizedSource))return'';
    if(/(?:\.\s*){8,}|(?:,\s*){10,}/.test(normalizedValue)||repeatedWordRun(normalizedValue))return'';
    if(/(?:Ã.|â€|ï¿½|�)/.test(normalizedValue))return'';
    return normalizedValue;
  }
  function compileDictionary(source){
    var compiled=Object.create(null);
    Object.keys(source||{}).forEach(function(rawSource){
      var normalizedSource=key(rawSource),replacement=safeTranslation(normalizedSource,source[rawSource]);
      if(normalizedSource&&replacement)compiled[normalizedSource]=replacement;
    });
    return compiled;
  }
  function compilePrefixes(source){
    return (source||[]).map(function(item){
      var normalizedSource=key(item&&item.source),replacement=safeTranslation(normalizedSource,item&&item.translation);
      return normalizedSource.length>=120&&replacement?{source:normalizedSource,translation:replacement}:null;
    }).filter(Boolean);
  }
  var dictionary=compileDictionary(rawDictionary);
  var enterpriseProse=compileDictionary(rawEnterpriseProse);
  var enterprisePrefixes=compilePrefixes(rawEnterprisePrefixes);
  var embeddedPairs=Object.keys(dictionary).filter(function(source){return source.length>=18;}).sort(function(a,b){return b.length-a.length;}).map(function(source){return[source,dictionary[source]];});
  function pageBuilderNoise(value){
    var normalized=key(value);
    return normalized.length<180&&(
      /^JSON-LD(?:\s+SCHEMAS?)?:?/i.test(normalized)||
      /^(?:STARFIELD(?: BG)?|HERO|INTRO SECTION|SECTION INTRO|SEÇÃO INTRODU|SECO INTRODU|FAQ SECTION|SECTION FAQ|SEÇÃO FAQ|SECO FAQ|CALCULATOR FORM|FORM CALCULATOR|FORMA DE CALCULATOR|RESULT|RESULTADO|ALL 12 VENUS SIGNS|TODOS OS 12 AVENUS SIGNS|CROSS ?LINKS|LINKS DE CROSS)$/i.test(normalized)
    );
  }
  function translated(value){var normalized=key(value);return normalized&&dictionary[normalized]||'';}
  function localizedDynamic(value){
    var language=String(document.documentElement.lang||'').toLowerCase();if(language.indexOf('pt')!==0)return value;
    var words={
      'Pull your Current Situation card from the shuffled deck':'Tire do baralho a carta da Situação atual','Pull your Key Tension card from the shuffled deck':'Tire do baralho a carta da Tensão principal','Pull your Constructive Response card from the shuffled deck':'Tire do baralho a carta da Resposta construtiva',
      'Current Situation card not chosen yet':'Carta da Situação atual ainda por escolher','Key Tension card not chosen yet':'Carta da Tensão principal ainda por escolher','Constructive Response card not chosen yet':'Carta da Resposta construtiva ainda por escolher',
      'Pull your Situação atual carta do baralho embaralhado':'Tire do baralho a carta da Situação atual','Pull your Tensão principal carta do baralho embaralhado':'Tire do baralho a carta da Tensão principal','Pull your Resposta construtiva carta do baralho embaralhado':'Tire do baralho a carta da Resposta construtiva',
      'Situação atual carta ainda por escolher':'Carta da Situação atual ainda por escolher','Tensão principal carta ainda por escolher':'Carta da Tensão principal ainda por escolher','Resposta construtiva carta ainda por escolher':'Carta da Resposta construtiva ainda por escolher','Suas três cartas escolhidas':'As suas três cartas escolhidas',
      'Return your Situação atual card to the deck':'Devolva a carta da Situação atual ao baralho','Return your Tensão principal card to the deck':'Devolva a carta da Tensão principal ao baralho','Return your Resposta construtiva card to the deck':'Devolva a carta da Resposta construtiva ao baralho',
      'Shuffle & Choose 3 Cards':'Embaralhar e escolher 3 cartas','Current Situation':'Situação atual','Key Tension':'Tensão principal','Constructive Response':'Resposta construtiva','Choose card':'Escolha a carta','Not chosen':'Por escolher','Reveal My 3 Cards':'Revelar as minhas três cartas','Change':'Alterar',
      'Escolha o carta':'Escolha a carta','Revelar meus 3 cartas':'Revelar as minhas três cartas','Escolha as 3 cartas que o puxam':'Escolha as três cartas que mais a atraem','Suas cartas assumirão esses papéis':'As suas cartas terão estas posições','âœ¦':'✦',
      'Upright in Situação atual position':'direita na posição Situação atual','Reversed in Situação atual position':'invertida na posição Situação atual','Upright in Tensão principal position':'direita na posição Tensão principal','Reversed in Tensão principal position':'invertida na posição Tensão principal','Upright in Resposta construtiva position':'direita na posição Resposta construtiva','Reversed in Resposta construtiva position':'invertida na posição Resposta construtiva',
      'Enlarge':'Ampliar','Upright':'direita','Reversed':'invertida','position':'posição','This week':'Esta semana','TODAY':'HOJE','Big Three':'Três Grandes','spread':'tiragem','spreads':'tiragens','Lilith in the':'Lilith na','Monday':'segunda-feira','Tuesday':'terça-feira','Wednesday':'quarta-feira','Thursday':'quinta-feira','Friday':'sexta-feira','Saturday':'sábado','Sunday':'domingo',
      'January':'janeiro','February':'fevereiro','March':'março','April':'abril','May':'maio','June':'junho','July':'julho','August':'agosto','September':'setembro','October':'outubro','November':'novembro','December':'dezembro'
    };
    Object.keys(words).forEach(function(source){var escaped=source.replace(/[.*+?^${}()|[\]\\]/g,'\\$&'),pattern=(/^\w/.test(source)?'\\b':'')+escaped+(/\w$/.test(source)?'\\b':'');value=value.replace(new RegExp(pattern,'gi'),words[source]);});return value;
  }
  function translatedText(value){
    var normalized=key(value),exact=normalized&&dictionary[normalized];if(exact)return localizedDynamic(exact);if(!normalized||normalized.length>1200)return'';
    var output=normalized;for(var i=0;i<embeddedPairs.length;i++){var source=embeddedPairs[i][0],replacement=embeddedPairs[i][1];if(output.indexOf(source)>=0)output=output.split(source).join(replacement);}
    output=localizedDynamic(output);
    return output===normalized?'':output;
  }
  function enterpriseTranslation(value){
    var normalized=key(value),exact=normalized&&enterpriseProse[normalized];
    if(exact)return exact;
    for(var i=0;i<enterprisePrefixes.length;i++){
      var item=enterprisePrefixes[i]||{},source=item.source,replacement=item.translation;
      if(source.length>=120&&replacement&&normalized.indexOf(source)===0)return replacement;
    }
    return'';
  }
  function textNode(node){
    if(!node||!node.parentElement||/^(?:SCRIPT|STYLE|NOSCRIPT|TEMPLATE)$/i.test(node.parentElement.tagName)||node.parentElement.closest('[data-deckaura-no-i18n],[translate="no"]'))return;
    if(pageBuilderNoise(node.nodeValue)){node.nodeValue='';return;}
    var replacement=translatedText(node.nodeValue);if(!replacement||replacement===key(node.nodeValue))return;
    var leading=(node.nodeValue.match(/^\s*/)||[''])[0],trailing=(node.nodeValue.match(/\s*$/)||[''])[0];node.nodeValue=leading+replacement+trailing;
  }
  function element(node){
    if(!node||node.nodeType!==1||node.closest('[data-deckaura-no-i18n],[translate="no"]'))return;
    attributes.forEach(function(attribute){var current=node.getAttribute(attribute),replacement=localizedDynamic(translated(current)||translatedText(current)||key(current));if(replacement&&replacement!==key(current))node.setAttribute(attribute,replacement);});
    if(node.matches('input[type="button"],input[type="submit"],input[type="reset"]')){var value=node.value,replacement=localizedDynamic(translated(value)||translatedText(value)||key(value));if(replacement&&replacement!==key(value))node.value=replacement;}
    if(node.matches('a[href]')){
      var href=node.getAttribute('href');
      if(href&&href.charAt(0)==='/'&&href.charAt(1)!=='/'){
        try{
          var parsed=new URL(href,window.location.origin),locale=String(document.documentElement.lang||'').toLowerCase(),routes=localizedRoutes[locale]||localizedRoutes[locale.split('-')[0]]||{},sourcePath=parsed.pathname.replace(new RegExp('^/'+locale.replace(/[.*+?^${}()|[\]\\]/g,'\\$&')+'(?=/|$)','i'),''),target=routes[sourcePath]||routes[parsed.pathname];
          if(target)node.setAttribute('href',target+parsed.search+parsed.hash);
        }catch(_){ }
      }
    }
  }
  function enterpriseBlock(node){
    if(!node||node.nodeType!==1||!/^(?:P|LI|DD|TD|TH|BLOCKQUOTE|DIV)$/i.test(node.tagName)||node.closest('[data-deckaura-no-i18n],[translate="no"]')||node.querySelector('button,input,select,textarea,iframe,video,audio'))return;
    if(node.tagName==='DIV'&&node.querySelector('div,p,ul,ol,table,section,article'))return;
    var replacement=enterpriseTranslation(node.textContent);if(!replacement||replacement===key(node.textContent))return;
    var links=node.querySelectorAll('a');
    if(!links.length){node.textContent=replacement;return;}
    if(links.length!==1)return;
    var link=links[0],label=key(link.textContent),position=label&&replacement.indexOf(label);if(position<0)return;
    node.replaceChildren(document.createTextNode(replacement.slice(0,position)),link,document.createTextNode(replacement.slice(position+label.length)));
  }
  function protectedNode(node){
    var owner=node&&node.nodeType===1?node:node&&node.parentElement;
    return !!(owner&&owner.closest('[data-deckaura-no-i18n],[translate="no"]'));
  }
  function blockWalk(root){
    if(!root||protectedNode(root))return;
    if(root.nodeType===1)enterpriseBlock(root);
    if(!document.createTreeWalker||!root.querySelectorAll)return;
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT,{acceptNode:function(node){
      if(node.matches('[data-deckaura-no-i18n],[translate="no"]'))return NodeFilter.FILTER_REJECT;
      return /^(?:P|LI|DD|TD|TH|BLOCKQUOTE|DIV)$/i.test(node.tagName)?NodeFilter.FILTER_ACCEPT:NodeFilter.FILTER_SKIP;
    }}),node;
    while((node=walker.nextNode()))enterpriseBlock(node);
  }
  function walk(root){
    if(!root||protectedNode(root))return;
    if(root.nodeType===3){textNode(root);return;}
    if(root.nodeType!==1&&root.nodeType!==9&&root.nodeType!==11)return;
    if(root.nodeType===1)element(root);
    var walker=document.createTreeWalker(root,NodeFilter.SHOW_ELEMENT|NodeFilter.SHOW_TEXT,{acceptNode:function(node){
      if(node.nodeType===1&&node.matches('[data-deckaura-no-i18n],[translate="no"]'))return NodeFilter.FILTER_REJECT;
      if(node.nodeType===3&&protectedNode(node))return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }}),node;
    while((node=walker.nextNode())){if(node.nodeType===3)textNode(node);else element(node);}
  }
  function start(){
    var scope=document.getElementById('MainContent')||document.querySelector('main')||document.body;
    if(!scope)return;
    walk(scope);blockWalk(scope);
    var roots=new Set(),texts=new Set(),elements=new Set(),blocks=new Set(),frame=0;
    var schedule=window.requestAnimationFrame||function(callback){return window.setTimeout(callback,16);};
    function addBlock(node){var owner=node&&node.nodeType===1?node:node&&node.parentElement;if(owner&&!protectedNode(owner))blocks.add(owner);}
    function flush(){
      frame=0;
      roots.forEach(walk);texts.forEach(textNode);elements.forEach(element);blocks.forEach(blockWalk);
      roots.clear();texts.clear();elements.clear();blocks.clear();
    }
    function queue(){if(!frame)frame=schedule(flush);}
    var observer=new MutationObserver(function(records){
      records.forEach(function(record){
        if(record.type==='characterData'){texts.add(record.target);addBlock(record.target);}
        else if(record.type==='attributes'){elements.add(record.target);addBlock(record.target);}
        else{
          Array.prototype.forEach.call(record.addedNodes,function(node){if(!protectedNode(node)){roots.add(node);addBlock(node);}});
          addBlock(record.target);
        }
      });
      queue();
    });
    observer.observe(scope,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:attributes.concat(['value'])});
    var language=String(document.documentElement.lang||'').split('-')[0].toLowerCase();
    document.documentElement.setAttribute('data-deckaura-tools-language',language);
    if(window.__DECKAURA_I18N_TEST__)window.__DeckauraToolsI18nTest={scope:scope,flush:flush,walk:walk,translatedText:translatedText};
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
